import type { TableTopComponentProps } from "app/components/React/Table/SWReactTableWrapper";
import type {
    ICategoryLeadersNavParams,
    ICategoryLeadersServices,
} from "app/pages/industry-analysis/category-leaders/CategoryLeaders.types";
import type {
    ICategoryLeadersTableQueryParams,
    ICategoryLeadersTableSort,
} from "../CategoryLeadersTable.shared.types";
import type { ECategoryLeadersMetricType } from "app/pages/industry-analysis/category-leaders/CategoryLeaders.types";

const CategoryLeadersTableExcelUrls = {
    categoryLeadersSearch: "/widgetApi/CategoryLeaders/CategoryLeadersSearch/Excel",
    categoryLeadersSocial: "/widgetApi/CategoryLeaders/CategoryLeadersSocial/Excel",
};

export const TABLE_SEARCH_FILTER_KEY = "Domain";

export interface ICategoryLeadersTableTopProps extends Omit<TableTopComponentProps, "sort"> {
    sort: ICategoryLeadersTableSort;
    services: ICategoryLeadersServices;
    tableQueryParams: ICategoryLeadersTableQueryParams;
    navParams?: ICategoryLeadersNavParams;
    excelApiEndpoint: string;
    metricType: ECategoryLeadersMetricType;
    totalCount?: number;
}
